<template>
  <div class="modal-window__wrap">
    <button
      type="button"
      @click="$emit('close')"
      class="button button--close"
      aria-label="close modal"
    >
      <font-awesome-icon icon="times-circle" />
    </button>
    <form>
      <Legend class="modal-window__title">Archive this timer</Legend>
      <fieldset
        class="modal-window__form-wrap modal-window__form-wrap--column layout--margin-bottom-md"
      >
        <strong>What happens when I archive a timer?</strong>
        <ul
          class="layout--margin-left-md layout--margin-top-md layout--margin-bottom-md"
        >
          <li>
            The timer will be deactivated and no longer count towards your
            impressions
          </li>
          <li>
            Within emails the timer will display the following message:<br />
            “This timer has been deactivated.”
          </li>
          <li>
            Archived timers can be viewed within the Archive tab on the
            dashboard
          </li>
          <li>
            From the Archive tab you can restore a timer in order to re-use it
          </li>
        </ul>
      </fieldset>

      <v-checkbox
        on-icon="mdi-check-box-outline"
        v-model="hideArchiveModalChecked"
        :hide-details="true"
        label="Don't show this message again"
      ></v-checkbox>

      <LoadingButton
        class="layout--margin-top-md"
        wide
        big
        :loading="archiving"
        :event="archiveTimer"
        label="Archive"
        loadingLabel="Archiving..."
      />

      <button
        type="button"
        class="button button--secondary button--big button--wide layout--margin-top-md"
        @click="$emit('close')"
      >
        Cancel
      </button>
    </form>
  </div>
</template>

<script>
import { mapWaitingActions } from "vue-wait";
import { mapGetters, mapMutations } from "vuex";
import LoadingButton from "./LoadingButton.vue";

export default {
  name: "archive-modal",
  props: { timer: Object },
  data() {
    return {
      archiving: false,
    };
  },
  computed: {
    ...mapGetters("account", ["hideArchiveModal"]),
    hideArchiveModalChecked: {
      get() {
        return this.hideArchiveModal;
      },
      set(value) {
        this.setHideArchiveModal(value);
      },
    },
  },
  methods: {
    ...mapWaitingActions("timers", {
      updateTimer: "updating timer",
    }),
    ...mapMutations("account", ["setHideArchiveModal"]),
    archiveTimer: function() {
      this.archiving = true;
      const newTimer = JSON.parse(JSON.stringify(this.timer));
      newTimer.widget.archived = true;
      newTimer.widget.active = false;
      this.updateTimer(newTimer.widget).then(() => {
        this.$emit("close");
      });
    },
  },
  components: { LoadingButton },
};
</script>

<style></style>
